import { Component, OnInit, ElementRef, AfterViewInit, ChangeDetectorRef, inject,ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StaticContentService } from '../../../app/service/features/static-content.service';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { utilGet,isValidURL } from '../../service/library/library';
import { ROUTES } from '../../app-routes.constant';
import { TdrsHttpEnvironmentService } from '../../service/environment';
import { downloadFile } from '../../common/file-download';
import { FILE_TYPES, WARNINGS,UploadStatus } from '../../app.constant';
import { UserDetailService } from '../../../app/service/common/user/user-detail.service';

@Component({
    selector: 'dd-review-guidelines',
    templateUrl: './review-guidelines.component.html',
    styleUrls: ['./review-guidelines.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReviewGuidelinesComponent implements OnInit, AfterViewInit {
  public legalGuideContent;
  public disclaimerContent;
  public photovideoguideContent;
  public legalData;
  public legalDataWarning;
  public disclaimerData;
  public disclaimerDataWarning;
  public photovideoguideData;
  public photovideoguideDataWarning;
  public selectedTab;
  public showSpinner = false;
  public showDisclaimer = false;
  public disclaimerFile: File = null;
  public disclaimerDate: Date | string = null;
  public isValidDisclaimerFile = true;
  public isDisclaimerDateNotEmpty = true;
  public isValidDisclaimerDate = true;

  public isSuperAdmin = false;

  public router = inject(Router);
  public sanitizer = inject(DomSanitizer);
  public tdrsHttpEnvironmentService = inject(TdrsHttpEnvironmentService);
  public activatedRoute = inject(ActivatedRoute);
  public cdr = inject(ChangeDetectorRef);
  public staticContentService = inject(StaticContentService);
  public elementRef = inject(ElementRef);
  public vps = inject(ViewportScroller);
  public userDetailService = inject(UserDetailService);


  getLegalGuideData() {
    this.showSpinner = true;
    this.staticContentService.getLegalGuidelinesData().subscribe({
      next: (res) => {
        if (res.body.statusCode === 200) {
          this.legalGuideContent = utilGet(res, 'body.data', '');
          this.legalGuideContent = this.legalGuideContent.split('""').join('"');
          this.legalGuideContent = this.legalGuideContent.split('href').join('data-tagName');
          this.legalData = this.legalGuideContent;
          this.addClickListener();
          this.showSpinner = false;
        } else {
          this.showSpinner = false;
          this.legalDataWarning = res.body.message;
        }
      },
      error: (e) => {
        this.showSpinner = false;
        this.legalDataWarning = WARNINGS.UnknownError;
        console.error(e);
      }
    });
  }

  /**
   * On click listener for Anchor tag click
   */
  addClickListener() {
    this.elementRef.nativeElement.addEventListener('click', (event: any) => {
      let index;
      const eventPath = event?.path || event?.composedPath();
      if (eventPath?.length > 0) {
        // get the index for the anchor tag element for which nodename is 'A'
        index = eventPath.findIndex((element) => element.nodeName === 'A');
        let dataTagName;
        let targetElement;
        // Get the target element tag name to which we need scroll
        if (index === 1 && eventPath[index]?.dataset?.tagname) {
          dataTagName = eventPath[index].dataset.tagname.slice(1);
        }
        // with the tag name select the target element
        if (dataTagName) {
          targetElement = this.elementRef.nativeElement.querySelector(`[name=${dataTagName}]`);
        }
        // scroll to the corresponding target element
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
      false
    );
  }

  getDisclaimerData() {
    this.isSuperAdmin = this.userDetailService?.isSuperAdmin();
    this.staticContentService.getDisclaimerData().subscribe({
      next: (res) => {
        this.showSpinner = true;
        if (res.body.statusCode === 200) {
          this.disclaimerContent = utilGet(res, 'body.data', '');
          this.disclaimerContentOperations();
          this.elementRef.nativeElement.addEventListener('click', (event: any) => {
            let index;
            const eventPath = event?.path || event?.composedPath();
            if (event && eventPath && eventPath.length > 0) {
              index = eventPath.findIndex((element) => element.nodeName === 'A');
              let dataTagName;
              if (index > -1 && eventPath[index]?.dataset?.apiurl) {
                dataTagName = eventPath[index].dataset.apiurl;
              }
              this.downloadFromAPI(dataTagName);
            }
          }, false);
        } else {
          this.disclaimerDataWarning = res.body.message;
        }
        this.showSpinner = false;
      },
      error: (e) => {
        this.disclaimerDataWarning = WARNINGS.UnknownError;
        this.showSpinner = false;
        console.error(e);
      }
    });
  }

  disclaimerContentOperations() {    
    // S5852: Use split/join instead of regex to avoid ReDoS    
    this.disclaimerContent = this.disclaimerContent.split('img src="').join('img src="assets/images/static-content');
    
    // Replace S3 URL with API URL
    const s3Pattern = 'tgpp-dev-use2-user-helpguides.s3.us-east-2.amazonaws.com/CurrentDisclaimer/MASTER_DISCLAIMERS_LIST-SEPT_18_2020.pdf';
    const apiUrl = this.tdrsHttpEnvironmentService.api.url + '/api/v1/review/guidelines/CurrentDisclaimersList';
    this.disclaimerContent = this.disclaimerContent.split(s3Pattern).join(apiUrl);
    
    // S5852: Use split/join instead of regex
    this.disclaimerContent = this.disclaimerContent.split('width="64"').join('width=64 hspace=10');
    this.disclaimerContent = this.disclaimerContent.split('href').join('data-apiurl');
    
    // CHANGED: Just set the string, don't bypass security here
    // The safeHtml pipe in the template will handle sanitization
    this.disclaimerData = this.disclaimerContent;
  }

  getPhotoVideoGuideData() {
    this.showSpinner = true;
    this.staticContentService.getPhotoVideoGuidelinesData().subscribe({
      next: (res) => {
        if (res.body.statusCode === 200) {
          this.photovideoguideContent = utilGet(res, 'body.data', '');
          this.photovideoguideContent = this.photovideoguideContent.split('img src="').join('img src="assets/images/static-content');
          this.photovideoguideData = this.photovideoguideContent;
        } else {
          this.photovideoguideDataWarning = res.body.message;
        }
        this.showSpinner = false;
      },
      error: (e) => {
        this.photovideoguideDataWarning = WARNINGS.UnknownError;
        this.showSpinner = false;
        console.error(e);
      }
    });
  }

  tabClick(event) {
    if (event?.index === 0) {
      this.router.navigate([ROUTES.REVIEW_GUIDELINES], { queryParams: { tab: 'legalGuidelines' } });
    }
    if (event?.index === 1) {
      this.router.navigate([ROUTES.REVIEW_GUIDELINES], { queryParams: { tab: 'currentDisclaimers' } });
    }
    if (event?.index === 2) {
      this.router.navigate([ROUTES.REVIEW_GUIDELINES], { queryParams: { tab: 'photovideoGuidelines' } });
    }
  }

  ngOnInit() {
    this.getLegalGuideData();
    this.getDisclaimerData();
    this.getPhotoVideoGuideData();
  }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params?.tagname === 'B') {
        setTimeout(() => {
          const dataTagName = params?.tagname;
          const targetElement = this.elementRef.nativeElement.querySelector(`[name=${dataTagName}]`);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
        }, 1000);
      }
      if (params.tab === 'legalGuidelines') {
        this.selectedTab = 0;
      }
      if (params.tab === 'currentDisclaimers') {
        this.selectedTab = 1;
      }
      if (params.tab === 'photovideoGuidelines') {
        this.selectedTab = 2;
      }
    });
    this.cdr.detectChanges();
  }

  downloadFromAPI(url) {
    if (isValidURL(url)) {
      this.showSpinner = true;
      let fileName = 'DISCLAIMERS LIST CLEAN & COMPARE 1.24.23.pdf';
      const myEle = document.getElementById("fileNameValue") as HTMLInputElement | null;      
      if(myEle) { 
        fileName = myEle.value;
      }     
      const updatedUrl = "CurrentDisclaimer/"+fileName;
      this.staticContentService.downLoadFiles(updatedUrl).subscribe({
        next: (res) => {
          downloadFile(res.body, fileName, FILE_TYPES.PDF);
          this.showSpinner = false;
        },
        error: () => {
          this.showSpinner = false;
        }
      });
    }
  }

  onFileAdding(event) {
    this.disclaimerFile = event.target.files[0];
  }

  /**
   * Validate and submit disclaimer form
   * S5852: Use ReDoS-safe date validation
   */
  disclaimerFormSubmit(disclaimerDate: Date | string) {
    this.disclaimerDate = disclaimerDate;
    let isValid = true;
    this.isValidDisclaimerDate = true;
    this.isDisclaimerDateNotEmpty = true;
    this.isValidDisclaimerFile = true;

    if (this.disclaimerDate) {
      // Convert to string if it's a Date object
      let dateStr: string;

      if (this.disclaimerDate instanceof Date) {
        const month = this.disclaimerDate.getMonth() + 1;
        const day = this.disclaimerDate.getDate();
        const year = this.disclaimerDate.getFullYear();
        dateStr = `${month}/${day}/${year}`;
      } else {
        dateStr = this.disclaimerDate;
      }

      // S5852: Validate date format without complex regex
      // Instead of regex, use simple validation
      isValid = this.isValidDateFormat(dateStr);
      if (!isValid) {
        this.isValidDisclaimerDate = false;
      }
    } else {
      isValid = false;
      this.isDisclaimerDateNotEmpty = false;
    }
    
    if (this.disclaimerFile == null) {
      isValid = false;
      this.isValidDisclaimerFile = false;
    }
    
    if (isValid) {
      this.showSpinner = true;
      this.staticContentService.getS3SignedUrlForFile(this.disclaimerFile.name, UploadStatus.NotStarted).subscribe({
        next: (fileRes) => {
          if (utilGet(fileRes, 'statusCode', null) === 200 && utilGet(fileRes, 'data', null) != null) {
            const signedUrl = utilGet(fileRes, 'data', null).data.signedURL;
            this.staticContentService.uploadDisclaimerFileWithSignedUrl(this.disclaimerFile, signedUrl).subscribe({
              next: () => {
                this.staticContentService.updateDisclaimerContent(this.disclaimerFile.name, UploadStatus.Success, this.disclaimerDate).subscribe({
                  next: (res1) => {
                    this.disclaimerContent = utilGet(res1, 'data', null).data.brandstandards;
                    this.disclaimerContentOperations();
                    this.showSpinner = false;
                    this.showDisclaimer = false;
                    this.disclaimerDate = null;
                    this.disclaimerFile = null;
                  }
                });
              }
            });
          }
        },
        error: () => {
          this.showSpinner = false;
          this.showDisclaimer = false;
          this.disclaimerDate = null;
          this.disclaimerFile = null;
        }
      });
    }
  }

  /**
   * Validate date format MM/DD/YYYY without using complex regex
   * S5852: ReDoS-safe validation using string operations
   */
  private isValidDateFormat(dateStr: string): boolean {
    if (!dateStr || typeof dateStr !== 'string') {
      return false;
    }

    // Split by /
    const parts = dateStr.split('/');
    
    // Must have exactly 3 parts
    if (parts.length !== 3) {
      return false;
    }

    // Parse parts
    const month = Number.parseInt(parts[0], 10);
    const day = Number.parseInt(parts[1], 10);
    const year = Number.parseInt(parts[2], 10);

    // Check for NaN
    if (Number.isNaN(month) || Number.isNaN(day) || Number.isNaN(year)) {
      return false;
    }

    // Validate ranges
    if (month < 1 || month > 12) {
      return false;
    }

    if (day < 1 || day > 31) {
      return false;
    }

    if (year < 1000 || year > 9999) {
      return false;
    }

    // Validate actual date correctness
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return false;
    }

    return true;
  }

  openDialog(modalValue) {    
    this.showDisclaimer = modalValue;
    if (!modalValue) {
      this.disclaimerDate = null;
      this.disclaimerFile = null;
      this.isValidDisclaimerDate = true;
      this.isValidDisclaimerFile = true;
    }
  }

  handlePrintEvent(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent default scrolling for Space
      globalThis.print();
    }
  }

  handleOpenDialogEvent(event: KeyboardEvent, param: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent default scrolling for Space
      this.openDialog(param);
    }
  }
}